import { createSelector } from '@reduxjs/toolkit'

import { RootState } from 'src/v2/store/store'

const uiState = (state: RootState) => state.ui

export const selectUICurrentTheme = createSelector(
  [uiState],
  (uiState) => uiState.currentTheme,
)

export const selectUICurrentThemeConfig = createSelector(
  [uiState],
  (uiState) => uiState.currentThemeConfig,
)
